<template>
  <div class="flex">
    <div class="margin10">
      <div class="title">阈值设置</div>
      <div class="yz">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E6%89%98%E7%AE%A1%E8%AE%BE%E7%BD%AE/%E5%9C%9F%E5%A3%A4%E6%B8%A9%E5%BA%A6%402x.png"
          alt=""
        />
        <div class="trwd" style="color: #b0d8c0">
          <div class="flex alit">
            <div class="">土壤温度高于</div>
            <el-input v-model="value1" class="yz-input1"></el-input>
            <div class="">℃</div>
          </div>
          <div class="flex alit margin10">
            <div class="">连续</div>
            <el-input v-model="value2" class="yz-input1"></el-input>
            <div class="">天</div>
          </div>
          <div class="flex alit">
            <div class="">亩均灌溉量</div>
            <el-input v-model="value3" class="yz-input1"></el-input>
            <div class="">m³/亩</div>
          </div>
        </div>
      </div>
      <div class="yz">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E6%89%98%E7%AE%A1%E8%AE%BE%E7%BD%AE/%E5%9C%9F%E5%A3%A4%E6%B9%BF%E5%BA%A6%402x.png"
          alt=""
        />
        <div class="trwd" style="color: #abb3dd">
          <div class="flex alit">
            <div class="">士壤湿度低于</div>
            <el-input v-model="value4" class="yz-input1"></el-input>
            <div class="">℃</div>
          </div>
          <div class="flex alit margin10">
            <div class="">亩均灌溉量</div>
            <el-input v-model="value5" class="yz-input1"></el-input>
            <div class="">m³/亩</div>
          </div>
        </div>
      </div>
      <div class="yz">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E6%89%98%E7%AE%A1%E8%AE%BE%E7%BD%AE/%E8%92%B8%E8%85%BE%402x.png"
          alt=""
        />
        <div class="trwd" style="color: #dfe1c4">
          <div class="flex alit">
            <div class="">蒸腾作用强度<br />(ET值)等于</div>
            <el-input v-model="value6" class="yz-input1"></el-input>
          </div>
          <div class="flex alit margin10">
            <div class="">亩均灌溉量</div>
            <el-input v-model="value7" class="yz-input1"></el-input>
            <div class="">m³/亩</div>
          </div>
        </div>
      </div>
      <div class="yz">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/%E6%89%98%E7%AE%A1%E8%AE%BE%E7%BD%AE/%E5%8F%B6%E7%89%87%E6%B8%A9%E5%BA%A6%402x.png"
          alt=""
        />
        <div class="trwd" style="color: #abb3dd">
          <div class="flex alit">
            <div class="">叶片温度高于</div>
            <el-input v-model="value8" class="yz-input1"></el-input>
            <div class="">℃</div>
          </div>
          <div class="flex alit margin10">
            <div class="">亩均灌溉量</div>
            <el-input v-model="value9" class="yz-input1"></el-input>
            <div class="">m³/亩</div>
          </div>
        </div>
      </div>
    </div>
    <div class="margin10">
      <div class="title">执行记录</div>
      <div class="aifx-title flex justb alit">
        <div class="" style="width: 25%">执行时间</div>
        <div class="" style="width: 25%">触发条件</div>
        <div class="" style="width: 25%">瞬时流量</div>
        <div class="" style="width: 25%">亩均灌溉量</div>
      </div>
      <vue-seamless-scroll
        :data="userRecards"
        class="warp"
        :class-option="classOption3"
        style="overflow: hidden; margin-top: 10px"
      >
        <ul class="item" style="list-style-type: none; padding: 0">
          <li
            v-for="(item, index) in userRecards"
            :key="index"
            class="flex alit"
            style="height: 36px; margin-bottom: 10px"
            :data="JSON.stringify(item)"
          >
            <div class="ai-list flex alit" style="flex: 1">
              <div class="" style="width: 25%">
                {{ item.exeTime }}
              </div>
              <div class="" style="width: 25%">
                {{ item.condition }}
              </div>
              <div class="textOne mjgg" style="width: 25%">
                {{ item.average }}m³
              </div>
              <div class="zgg" style="width: 25%">{{ item.summary }}m³</div>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      value1: "30",
      value2: "7",
      value3: "24",
      value4: "40",
      value5: "21",
      value6: "6",
      value7: "22",
      value8: "35",
      value9: "19",
      taskList: [],
      classOption3: {
        singleHeight: 46,
        limitMoveNum: 11,
        hoverStop: true,
        waitTime: 4000,
      },
      userRecards: [
        {
          exeTime: "2025-07-18 18:45",
          condition: "土壤温度高于 28℃",
          average: 0.027,
          summary: 12,
        },
        {
          exeTime: "2025-07-18 19:15",
          condition: "土壤湿度低于 18%",
          average: 0.034,
          summary: 14,
        },
        {
          exeTime: "2025-07-18 20:00",
          condition: "蒸腾作用强度(ET值) > 3.8",
          average: 0.021,
          summary: 15,
        },
        {
          exeTime: "2025-07-19 06:30",
          condition: "叶片温度高于 32℃",
          average: 0.025,
          summary: 13,
        },
        {
          exeTime: "2025-07-19 07:45",
          condition: "土壤温度高于 30℃",
          average: 0.03,
          summary: 16,
        },
        {
          exeTime: "2025-07-19 09:00",
          condition: "土壤湿度低于 15%",
          average: 0.038,
          summary: 17,
        },
        {
          exeTime: "2025-07-19 10:30",
          condition: "蒸腾作用强度(ET值) > 4.0",
          average: 0.024,
          summary: 14,
        },
        {
          exeTime: "2025-07-19 12:00",
          condition: "叶片温度高于 33℃",
          average: 0.028,
          summary: 15,
        },
        {
          exeTime: "2025-07-19 13:30",
          condition: "土壤温度高于 31℃",
          average: 0.032,
          summary: 16,
        },
        {
          exeTime: "2025-07-19 14:45",
          condition: "土壤湿度低于 17%",
          average: 0.035,
          summary: 18,
        },
        {
          exeTime: "2025-07-20 05:30",
          condition: "蒸腾作用强度(ET值) > 3.9",
          average: 0.023,
          summary: 13,
        },
        {
          exeTime: "2025-07-20 06:45",
          condition: "叶片温度高于 34℃",
          average: 0.029,
          summary: 14,
        },
        {
          exeTime: "2025-07-20 08:00",
          condition: "土壤温度高于 29℃",
          average: 0.031,
          summary: 15,
        },
        {
          exeTime: "2025-07-20 09:30",
          condition: "土壤湿度低于 16%",
          average: 0.036,
          summary: 17,
        },
        {
          exeTime: "2025-07-20 10:45",
          condition: "蒸腾作用强度(ET值) > 4.1",
          average: 0.025,
          summary: 15,
        },
        {
          exeTime: "2025-07-20 12:15",
          condition: "叶片温度高于 35℃",
          average: 0.03,
          summary: 16,
        },
        {
          exeTime: "2025-07-20 13:45",
          condition: "土壤温度高于 32℃",
          average: 0.033,
          summary: 17,
        },
        {
          exeTime: "2025-07-20 15:00",
          condition: "土壤湿度低于 19%",
          average: 0.037,
          summary: 18,
        },
        {
          exeTime: "2025-07-20 16:30",
          condition: "蒸腾作用强度(ET值) > 4.2",
          average: 0.026,
          summary: 14,
        },
        {
          exeTime: "2025-07-20 17:45",
          condition: "叶片温度高于 36℃",
          average: 0.031,
          summary: 15,
        },
      ],
    };
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getLeftBottomData();
  },
  methods: {
    getLeftBottomData() {
      this.$request(`iot/screen/plot/listTask?startDate=&endDate=`).then(
        (res) => {
          this.taskList = res.data;
        }
      );
    },
  },
};
</script>

<style>
.yz-input1 .el-input__inner {
  height: 35px;
  border: none;
  font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
  font-weight: 400;
  font-size: 20px;
  text-shadow: 0px 3px 7px rgba(53, 44, 0, 0.5);
  text-align: center;
  font-style: normal;
  text-decoration-line: underline;
  text-transform: none;
  background: linear-gradient(90deg, #ffffff 15%, #f7ff57 81%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
</style>
<style lang="scss" scoped>
.ai-list {
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  .mjgg {
    font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 20px;
    line-height: 20px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(90deg, #ffffff 15%, #f7ff57 81%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .zgg {
    font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 20px;
    line-height: 20px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(90deg, #fefeff 0%, #73aeff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.warp {
  height: 550px;
  width: 100%;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.01);
  display: block;

  .yujing {
    width: 410px;
    height: 30px;
    background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E9%A2%84%E8%AD%A6%E8%83%8C%E6%99%AF%402x.png");
    background-size: 100% 100%;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 30px;

    // background: red;
    .yujing-type {
      width: 63px;
      height: 22px;
      background: linear-gradient(
        270deg,
        rgba(43, 85, 145, 0.5) 0%,
        rgba(30, 83, 133, 0.5) 100%
      );
      border-radius: 28px;
      border: 1px solid #0083ff;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      margin: 0 10px;

      img {
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }
    }
  }

  .item {
    padding: 0;
  }

  ul {
    list-style: none;
    padding: 10px 0;
    margin: 0;
    width: 100%;
    // background-color: rgba(255, 255, 255, 0.1);

    li {
      height: 50px;
    }

    li:hover {
      background-color: #01a8ff;
    }
  }
}
.aifx-title {
  width: 790px;
  height: 36px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png");
  background-size: 100% 100%;

  font-weight: 500;
  font-size: 14px;
  color: #00ffd1;
  text-align: center;
}
.yz {
  margin: 30px 0;
  img {
    width: 400px;
    height: 110px;
  }

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  .yz-input1 {
    flex: 1;
    height: 35px;
    background: rgba(47, 133, 212, 0.2) !important;
    border-radius: 4px 4px 4px 4px !important;
    margin: 0 10px;
  }

  .trwd {
    margin-top: -100px;
    margin-left: 95px;
    width: 310px;
  }
}
.margin10 {
  margin: 10px 0;
}
</style>